module.exports = __webpack_public_path__ + "img/ae-2.18b275d.png";